var map = {
	"./cs.json": [
		78272,
		78272
	],
	"./de.json": [
		59377,
		59377
	],
	"./en.json": [
		80517,
		80517
	],
	"./es.json": [
		77966,
		77966
	],
	"./fr.json": [
		60934,
		60934
	],
	"./it.json": [
		2060,
		79679
	],
	"./ja.json": [
		79067,
		79067
	],
	"./ko.json": [
		82956,
		82956
	],
	"./pl.json": [
		33442,
		33442
	],
	"./pt-br.json": [
		12557,
		12557
	],
	"./pt.json": [
		86186,
		86186
	],
	"./ru.json": [
		89327,
		89327
	],
	"./tr.json": [
		67816,
		67816
	],
	"./zh.json": [
		66160,
		66160
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 15543;
module.exports = webpackAsyncContext;